export default function splitRangeIntoTwoPartsIfItIsCircular(range, sequenceLength) {
  if (sequenceLength !== 0) {
    sequenceLength = sequenceLength || Infinity;
  }
  const ranges = [];
  if (range.start > range.end) {
    ranges.push({
      start: 0,
      end: range.end,
      type: "end"
    });
    ranges.push({
      start: range.start,
      end: sequenceLength - 1,
      type: "beginning"
    });
  } else {
    ranges.push({
      start: range.start,
      end: range.end,
      type: "beginningAndEnd"
    });
  }
  return ranges;
}
